import React, { ReactNode, useEffect, useState } from 'react';
import { FormField } from '@grnhse/seedling/lib/azalea/components/forms/layout';
import { WarningCallOut } from '@grnhse/seedling/lib/birch/components/call_out';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import InlineBody from 'shared/components/inline_body';
import { withLocalePrefix } from 'shared/utils/translation';
import styled from 'styled-components';
import { Body } from '@grnhse/seedling/lib/birch/typography';
const t = withLocalePrefix(
  'candidate_profile_redesign.modals.email.domain_warning'
);

const BodyText = styled(Body)`
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
`;

const WarningMessage = ({ domain }: { domain: string | undefined }) => {
  return (
    <BodyText>
      {t('body') + ' '}
      <InlineBody medium>{domain ?? ''}</InlineBody>
      {' ' + t('body_2') + ' '}
    </BodyText>
  );
};

type FromValue = {
  domain_unverified?: boolean;
  domain?: string;
};

const EmailDomainWarningCallout = ({
  valueToWatch = 'from',
  compact = false,
  fromValue = null,
}: {
  valueToWatch?: string;
  compact?: boolean;
  fromValue?: FromValue | null;
}) => {
  const { watch } = useFormContext();
  const [displayDomainWarning, setDisplayDomainWarning] = useState(false);
  if (valueToWatch) {
    fromValue = watch(valueToWatch);
  }
  useEffect(() => {
    if (!fromValue) {
      setDisplayDomainWarning(false);
      return;
    }
    setDisplayDomainWarning(fromValue.domain_unverified ?? false);
  }, [fromValue]);
  if (!displayDomainWarning) {
    return null;
  }
  const Parent = ({ children }: { children: ReactNode }) =>
    compact ? <>{children}</> : <FormField>{children}</FormField>;

  return (
    <Parent>
      <WarningCallOut
        headerText={t('header')}
        bodyText={<WarningMessage domain={fromValue?.domain} />}
        linkProps={{
          children: t('call_to_action'),
          href: 'https://greenhouse.zendesk.com/hc/en-us/articles/201111684',
          target: '_blank',
        }}
        data-provides="email-domain-warning-callout"
      />
    </Parent>
  );
};

export default EmailDomainWarningCallout;
